import React, { useContext, useRef, useState } from 'react';
import { FC } from 'react';
import { Wrapper } from '@components/Lecturer/Lecturer.elements';
import TrainingLecturerTemplate from '@components/TrainingLecturer/TrainingLecturer';
import { ILecturerItem } from '../../interfaces/Lecturer';

interface LecturerProps {
    lecturer: ILecturerItem;
}

const LecturerTemplate: FC<LecturerProps> = ({ lecturer }) => (
    <Wrapper>
        <TrainingLecturerTemplate lecturer={lecturer} isDetailPage />
    </Wrapper>
);

export default LecturerTemplate;
